import React from "react";
import { Link } from "react-router-dom";

type Props = {
  oilRequest: any;
};

const CopyOilRequestButton: React.FC<Props> = ({
  oilRequest,
}): React.ReactElement => {
  return (
    <Link
      to={`/oil-requests/create?prefill=${oilRequest.id}`}
      className="btn-link me-auto"
    >
      Kopeeri
    </Link>
  );
};

export default CopyOilRequestButton;
